import { APIService } from "../../../../network/api/APIService";


export const ResetPasswordCALL = (formData) => {
  return APIService({
      endpoint: "/authentication/reset-password/",
      method: "PUT",
      data: formData
  });
};